import { render, staticRenderFns } from "./UpdateAndFix.vue?vue&type=template&id=458ac16c&scoped=true"
import script from "./UpdateAndFix.vue?vue&type=script&lang=js"
export * from "./UpdateAndFix.vue?vue&type=script&lang=js"
import style0 from "./UpdateAndFix.vue?vue&type=style&index=0&id=458ac16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ac16c",
  null
  
)

export default component.exports